import { useTranslation } from 'react-i18next';
import { resources } from '../../apps/benefit/resources/resources';
import ErrorIllustration from '../../common/assets/images/emptystates/error-illustration.svg';

interface ErrorPanelProps {
  message?: string;
}

export const ErrorPanel = (props: ErrorPanelProps) => {
  const { message } = props;
  const { t: translate } = useTranslation();
  return (
    <div className="error-section">
      <div className="error-section-image">
        <img src={ErrorIllustration} alt="Error illustration" />
      </div>
      <div className="error-section-text">
        <h3>{message ?? translate(resources.errorPanel.title)}</h3>
        <p>{translate(resources.errorPanel.subtitle)}</p>
      </div>
    </div>
  );
};
